import { Fragment, useEffect, useState } from 'react';
import { func, object } from 'prop-types';
import cn from 'classnames';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import useResponsive from '../../hooks/useResponsive';
import { checkPathMatch } from '../../utils/helpers';
import { ReactComponent as Arrow } from '../../styles/icon/arrow-pink.svg';
import { ReactComponent as ApisIcon } from '../../styles/icon/menu/apis.svg';
// import { setMenuToggle } from '../../redux/mobileMenuDocs/mobileMenuDocsActions';
import DropDown from '../../elements/DropDown/DropDown';
import Routes from '../../components/Routes';
import UniLoader from '../../components/UniLoader';

import docs from './CombinedDocs.module.scss';
import dropdown from '../../elements/DropDown/DropDown.module.scss';

const mapStateToProps = (state) => ({
  infoApi: state.info.data,
  infoApiLoading: state.info.loading,
  subMenu: state.swaggerApi.subMenu,
  subMenuLoading: state.swaggerApi.loading,
  isSwitcherOpen: state.switcher.isSwitcherOpen,
});

const mapDispatchToProps = {};

Apis.propTypes = {
  location: object,
  // setMenuToggle: func,
  callback: func,
};

function Apis(props) {
  const [activeAccordions, setActiveAccourdion] = useState('');

  const {
    location,
    infoApi,
    infoApiLoading,
    subMenu,
    subMenuLoading,
    isSwitcherOpen,
    // isMenuDocsOpen,
    // setMenuToggle,
    callback,
  } = props;
  const { isMobile } = useResponsive();
  const pathName = location.pathname;
  const hash = location.hash.replaceAll(' ', '%20');

  const handleDropdownClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    if (location.pathname.indexOf('/docs/apis') === -1) {
      setActiveAccourdion('');
    }
  }, [location]);

  useEffect(() => {
    const isApiPage = pathName.indexOf('/docs/apis') != -1;
    if (isApiPage) {
      const name = pathName.split('/');
      setActiveAccourdion(name[name.length - 1]);
    }
  }, [pathName]);

  function handleAccordions(name) {
    if (activeAccordions == name) {
      setActiveAccourdion('');
    } else {
      setActiveAccourdion(name);
    }
  }
  return (
    <div className={docs.docs__block}>
      <div className={docs.docs__title_wrapper}>
        <span>
          <ApisIcon />
        </span>
        <h4 className={docs.docs__menu_title}>API reference</h4>
      </div>
      <div className={docs.docs__list}>
        {infoApiLoading && <UniLoader isSwitcherOpen={isSwitcherOpen} size={20} />}
        {!infoApiLoading &&
          infoApi.map((c, i) => {
            const isPathMatch = checkPathMatch(`docs/apis/${c.id}`, pathName);
            const isOpen = isPathMatch && activeAccordions === c.id;

            return (
              <Fragment key={c.id + activeAccordions}>
                <div
                  className={cn(docs.docs__list_item, {
                    [docs['docs__list_item--active']]: isPathMatch && activeAccordions === c.id,
                    [docs['docs__list_item--open']]:
                      !hash && isPathMatch && activeAccordions === c.id,
                  })}
                >
                  <DropDown
                    className={dropdown.dropdown__full_width}
                    classNameTrigger={cn({
                      [docs['docs__link_menu--active']]:
                        isPathMatch && !hash && activeAccordions === c.id,
                      [docs['docs__link_menu--open']]: isPathMatch && activeAccordions === c.id,
                    })}
                    classNameBody={cn(dropdown.dropdown__doc)}
                    trigger={() => (
                      <div
                        className={cn(docs.docs__link_menu, {
                          'accordion-menu-show': isOpen && activeAccordions === c.id,
                          'accordion-menu-hide': !!isPathMatch && activeAccordions !== c.id,
                        })}
                      >
                        {!isMobile ? (
                          <div className={docs.docs__accordion}>
                            <div
                              className={docs.docs__accordion_title}
                              onClick={() => {
                                if (!isPathMatch || !activeAccordions) {
                                  handleAccordions(c.id);
                                }
                              }}
                            >
                              <Link
                                to={
                                  Routes.routes.FINTODOCS.routes.APIS.routes.SWAGGER.path +
                                  '/' +
                                  c.id
                                }
                              >
                                <span>{c.headerName}</span>
                              </Link>
                            </div>
                            <div
                              className={docs.docs__accordion_arrow}
                              onClick={() => {
                                if (!isPathMatch) {
                                  props.history.push(
                                    Routes.routes.FINTODOCS.routes.APIS.routes.SWAGGER.path +
                                      '/' +
                                      c.id
                                  );
                                }
                                handleAccordions(c.id);
                              }}
                            >
                              <Arrow />
                            </div>
                          </div>
                        ) : (
                          <div className={docs.docs__sandbox_mobile}>
                            <div
                              className={cn(
                                docs.docs__sandbox_mobile,
                                docs['docs__sandbox_mobile--dropdown']
                              )}
                            >
                              <Link
                                to={
                                  Routes.routes.FINTODOCS.routes.APIS.routes.SWAGGER.path +
                                  '/' +
                                  c.id
                                }
                              >
                                <span data-url-name={c.headerName}>{c.headerName}</span>
                              </Link>
                            </div>
                            <div
                              className={cn(
                                docs.docs__sandbox_mobile,
                                docs['docs__sandbox_mobile--separator']
                              )}
                              onClick={() => {
                                if (c.id === activeAccordions) {
                                  setActiveAccourdion('');
                                } else {
                                  setActiveAccourdion(c.id);
                                }
                                callback();
                              }}
                            >
                              <div
                                className={cn(
                                  docs.docs__sandbox_mobile,
                                  docs['docs__sandbox_mobile--arrow']
                                )}
                              >
                                <Link
                                  to={
                                    Routes.routes.FINTODOCS.routes.APIS.routes.SWAGGER.path +
                                    '/' +
                                    c.id
                                  }
                                >
                                  {subMenuLoading && isPathMatch ? (
                                    <div className={cn(docs.docs__loader_wrapper)}>
                                      <UniLoader size={20} />
                                    </div>
                                  ) : (
                                    <Arrow />
                                  )}
                                </Link>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    isOpened={isPathMatch && activeAccordions == c.id}
                    handleClose={() => {}}
                    onTriggerClick={handleDropdownClick}
                  >
                    {subMenu &&
                      isPathMatch &&
                      !subMenuLoading &&
                      subMenu.map((item) => {
                        return (
                          <div
                            className={cn(docs.docs__link_menu_item, {
                              [docs['docs__link_menu_item--active']]:
                                item.anchor.replaceAll(' ', '%20') === hash,
                            })}
                            key={item.name}
                          >
                            <Link
                              to={
                                Routes.routes.FINTODOCS.routes.APIS.routes.SWAGGER.path +
                                '/' +
                                c.id +
                                item.anchor
                              }
                            >
                              <span data-url-name={item.name}>
                                {item.name.replaceAll('-', ' ')}
                              </span>
                            </Link>
                          </div>
                        );
                      })}
                    {subMenuLoading && isPathMatch && !isMobile && (
                      <div className={cn(docs.docs__loader_wrapper)}>
                        <UniLoader size={20} />
                      </div>
                    )}
                  </DropDown>
                </div>
              </Fragment>
            );
          })}
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Apis));
